import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../../constants/level/api'

export const levelAll: ApiFunc<`${typeof API.LEVEL_ALL}`, 'get'> = data =>
  getInstance().get(API.LEVEL_ALL, {
    params: data,
  })
